import { useChannels } from 'providers/useChannels/useChannels';
import { TVAssetEntitlementState } from 'types/Entitlement';

type EntitlementCheckInput = {
    additional_services_available?: boolean;
    channel_id?: string;
    channelId?: string;
    [key: string]: unknown;
};

export const useTVAssetEntitlementState = () => {
    const { getChannelById } = useChannels();

    return (input: EntitlementCheckInput): TVAssetEntitlementState => {
        if (input == null) {
            return null;
        }

        const channelId = input.channel_id ?? input.channelId;
        const matchedChannel = channelId ? getChannelById(channelId) : null;

        if (matchedChannel) {
            if (input.additional_services_available === true && matchedChannel.additional_services_available === true) {
                return TVAssetEntitlementState.SHOULD_SUBSCRIBE_CHANNEL;
            }
            return TVAssetEntitlementState.ENTITLED;
        }

        if (input.additional_services_available === true) {
            return TVAssetEntitlementState.SHOULD_SUBSCRIBE_CHANNEL;
        }

        return TVAssetEntitlementState.ENTITLED;
    };
};
